import React from 'react';
import CallPayoutComponent from '../../../Components/Report/CallPayout';

export default function CallPayout() {
    return (
        <div className='page-body'>
            <CallPayoutComponent />
        </div>
    );
}